/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}

/**
 * 获取版本编号
 * @returns {string} 返回版本编号
 */
export function filterVersion() {
  const environment = process.env.VUE_APP_ENV
  if (environment === 'development') {
    return 'DEVD'
  } else if (environment === 'beta') {
    return 'BETA'
  } else if (environment === 'production') {
    return 'PROD'
  }
}

export function getUrlParams() {
  const params = new URLSearchParams(window.location.search);
  const result = {};
  for (const [key, value] of params.entries()) {
    // 处理重复参数，转换为数组
    if (result.hasOwnProperty(key)) {
      result[key] = [].concat(result[key], value)
    } else {
      result[key] = value
    }
  }
  return result
}

export function getRootDomain() {
  const hostname = location.hostname
  const parts = hostname.split('.')

  // 处理常见的双后缀
  const publicSuffixes = ['co.uk', 'com.cn', 'org.cn', 'net.cn', 'com.au', 'gov.uk']
  const lastTwo = parts.slice(-2).join('.')

  if (publicSuffixes.includes(lastTwo) && parts.length > 2) {
    return parts.slice(-3).join('.') // 取后三个部分
  }
  return parts.slice(-2).join('.') // 取后两个部分
}
